import styled from 'styled-components';
import { layoutLRPadding } from 'ui/theme/spacing';
import { PaginationFooter } from 'ui/paginationFooter';
import { usePaginationContext } from 'utils/contexts/pagination';
import { useHandlePaginationUpdate } from './hooks';
import { useListsContext } from '../contexts';

const StyledPaginationFooter = styled(PaginationFooter)`
  margin: 0 -${layoutLRPadding};
`;

export const DATA_TEST = {
  footer: 'list-pagination-footer',
};

export const ListPaginationFooter = () => {
  const { pageSize, currentPage } = usePaginationContext();
  const { totalSize } = useListsContext();
  const handlePaginationUpdate = useHandlePaginationUpdate();

  return (
    totalSize !== 0 && (
      <StyledPaginationFooter
        data-test={DATA_TEST.footer}
        currentPage={currentPage}
        itemsPerPage={pageSize}
        numItems={totalSize}
        onUpdate={handlePaginationUpdate}
      />
    )
  );
};
